import React from 'react';
import { Card, CardTitle, CardBody, ModalBody } from 'shards-react';

interface ModalEditBodyDeleteProps {
  description: string;
  title: string;
  message: string;
}

const ModalEditBodyDelete = ({ description, title, message }: ModalEditBodyDeleteProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <p>{description}</p>
      <Card className="mb-3">
        <CardBody>
          <CardTitle style={{ fontSize: '1rem' }}>{title}</CardTitle>
          <p>{message}</p>
        </CardBody>
      </Card>
    </ModalBody>
  );
};

export default ModalEditBodyDelete;
